import { Button } from '@mantine/core';
import { useChat } from 'src/hooks/useChat';
import { useAppSelector } from 'src/redux/redux-store/hooks';

const AskQuestionButton = () => {
  const { getChildSessionQuestion } = useChat();

  const selectedSessionId = useAppSelector(
    (state) => state.chat.selectedSession
  );
  const selectedLevel = useAppSelector((state) => state.user.level);
  const selectedSubject = useAppSelector((state) => state.chat.activeSubject);
  const isStreaming = useAppSelector((state) => state.chat.streaming);

  const handleAskQuestion = () => {
    if (selectedSessionId?.id && selectedLevel && selectedSubject) {
      getChildSessionQuestion(
        selectedSessionId.id,
        selectedLevel,
        selectedSubject
      );
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleAskQuestion}
      disabled={isStreaming}
      className="m-0 border-gray-200 cursor-pointer hover:bg-gray-50 shadow-sm transition-all rounded-full mb-1"
    >
      Ask me a question
    </Button>
  );
};

export default AskQuestionButton;
